// 슬롯 호스트 — 코어가 연 자리에 플러그인 위젯을 priority 순으로 그린다. 위젯마다 ErrorBoundary (ADR-048 D3·D5)
import { useLocation } from 'react-router';

import { usePluginHost } from '../composition/plugin-host-context';
import { PluginErrorBoundary } from '../composition/plugin-runtime/boundary';
import type { SlotKey } from '../ports/slots';

export function SlotHost({ slot }: { slot: SlotKey }) {
  const host = usePluginHost();
  // 화면을 옮기면 실패한 위젯도 한 번 더 그려 본다 — 한 번 실패로 레이아웃이 살아 있는 내내 비지 않게
  const { pathname } = useLocation();
  return (
    <>
      {host.slots(slot).map(({ id, plugin, component: Widget }) => (
        <PluginErrorBoundary key={id} plugin={plugin} onError={host.reportError} resetKey={pathname}>
          <Widget />
        </PluginErrorBoundary>
      ))}
    </>
  );
}
